module.exports = __webpack_public_path__ + "img/brand_0.cee62363.png";